module.exports = __webpack_public_path__ + "img/audio.71f6fba2.svg";